import { ActionSheetController } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { Media, MediaObject } from '@ionic-native/media/ngx';
import {
  CaptureError,
  CaptureVideoOptions,
  MediaCapture,
  MediaFile,
} from '@ionic-native/media-capture/ngx';
import { File, FileEntry } from '@ionic-native/file/ngx';
import { Storage } from '@ionic/storage';
import {
  StreamingMedia,
  StreamingVideoOptions,
} from '@ionic-native/streaming-media/ngx';
import { PhotoViewer } from '@ionic-native/photo-viewer/ngx';
import { VideoEditor } from '@ionic-native/video-editor/ngx';
import { CrashService } from './crash.service';

export const MEDIA_FILES_KEY = 'mediaFiles';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  currentImage: any;
  audio: MediaObject = null;
  audioPlaying = false;
  mediaFiles = [];

  constructor(
    private crash: CrashService,
    public camera: Camera,
    public media: Media,
    private mediaCapture: MediaCapture,
    public actionSheetController: ActionSheetController,
    public file: File,
    private storage: Storage,
    private streamingMedia: StreamingMedia,
    private photoViewer: PhotoViewer,
  ) {}

  /*
  PICTURES
  */

  pickImage(sourceType: number) {
    const options: CameraOptions = {
      sourceType,
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
    };

    this.camera.getPicture(options).then(
      (imageData) => {
        this.currentImage = 'data:image/jpeg;base64,' + imageData;
      },
      (err) => {
        // Handle error
        this.crash.process('media-service', 'pickImage', `Camera error`, {
          err,
        });
      },
    );
  }

  async pickMedia() {
    const options: CameraOptions = {
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      quality: 50,
      destinationType: this.camera.DestinationType.FILE_URI,
      mediaType: this.camera.MediaType.ALLMEDIA,
    };

    return await this.camera.getPicture(options);
  }

  // JL_TODO: is this even used?
  sendMedia() {
    console.log('Send the picture here...');
  }

  /*
  AUDIO
  */

  // JL_TODO: this isn't ven used
  // Listen to plugin events
  async bindAudioEvents() {
    await this.audio.onStatusUpdate.subscribe((status) => {
      console.log(status);
      switch (status) {
        case 1:
          console.log('Started recording');
          this.audioPlaying = true;
          break;
        case 2:
          console.log('Finished recording');
          this.audioPlaying = false;
          break;
        case 4:
          console.log('Stopped recording');
          this.audioPlaying = false;
          break;
      }
    }); // Fires when file status changes
    this.audio.onSuccess.subscribe(() => console.log('Action is successful'));
    this.audio.onError.subscribe((error) => {
      this.crash.process('media-service', 'bindAudioEvents', `Failed to bind`, {
        error,
      });
    });
  }

  recordAudio() {
    this.file
      .createFile(this.file.tempDirectory, 'my_file.wav', true)
      .then(async () => {
        this.audio = this.media.create(
          this.file.tempDirectory.replace(/^file:\/\//, '') + 'my_file.wav',
        );
        await this.bindAudioEvents();
        this.audio.startRecord();
        window.setTimeout(() => this.audio.stopRecord(), 5000);
      });
  }

  playAudio() {
    if (!this.audioPlaying) {
      this.audioPlaying = true;
      this.audio.play();
    }
  }

  stopAudio() {
    if (this.audioPlaying) {
      this.audioPlaying = false;
      this.audio.stop();
    }
  }

  clearAudio() {
    if (this.audio) {
      this.audio.release(); // Clear it from device
    }
  }

  sendAudio() {
    if (this.audio) {
      console.log('Send the audio clip here...');
      this.audio.release(); // Clear it from device
      this.clearAudio();
    } else {
      console.log('Nothing to send');
    }
  }

  openFile(media) {
    switch (media.type) {
      case 'image/jpg':
      case 'image/jpeg':
      case 'image/gif':
      case 'image/png':
      case 'image/bmp':
        console.log('Use the Photoviewer to present an Image');
        this.photoViewer.show(media.url);
        break;
      case 'video/mpeg':
      case 'video/mp4':
      case 'video/quicktime':
      case 'video/h264':
        console.log('Use the Streaming Media plugin to play a video');
        const optionsMp4: StreamingVideoOptions = {
          // successCallback: () => {
          //   console.log('Mp4 Video played');
          // },
          // errorCallback: (e) => {
          //   console.log('Error streaming Mp4', e);
          // },
          shouldAutoClose: false, //,
          // controls: true,
        };
        this.streamingMedia.playVideo(media.url, optionsMp4);
        break;
      case 'video/3gp':
      case 'video/3gpp':
        // console.log(`why are we trying to play 3gpp - that doesn't work`);
        // const options3gpp: StreamingVideoOptions = {
        //   successCallback: () => {
        //     console.log('3gpp Video played');
        //   },
        //   errorCallback: (e) => {
        //     console.log('Error streaming 3gpp', e);
        //   },
        //   shouldAutoClose: false,
        //   controls: true,
        // };
        // this.streamingMedia.playVideo(media.url, options3gpp);
        // this.play3gppVideo(media);
        break;
    }
  }
}
